import { LOADING } from "../../../constants/constant";
import {
    GET_REJECTED_BOTS_FOR_ADMIN_SUCCESS,
    GET_REJECTED_BOTS_FOR_ADMIN,
    GET_REJECTED_BOTS_FOR_ADMIN_FAILED,
    GET_REJECTED_BOTS_FOR_ADMIN_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getAdminRejectedBotsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_REJECTED_BOTS_FOR_ADMIN: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case GET_REJECTED_BOTS_FOR_ADMIN_SUCCESS: {
      let userRes = Object.assign({}, state);
      // console.log(
      //   "getCarrierSubmittedBotsReducer => Case => Success: while getting submitted bots list: " +
      //     JSON.stringify(action.data)
      // );
      userRes.status = action.data.statusMessage;
      userRes.statusCode = action.data.statusCode;
      userRes.isLoading = false;
      //   userRes.statusCode = action.data.status;
      userRes.botList = action.data.data;

      return userRes;
    }
    case GET_REJECTED_BOTS_FOR_ADMIN_FAILED: {
      console.error(
        "getAdminApprovedBotsReducer => Case => Error: while getting bots list: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);
    }

    case GET_REJECTED_BOTS_FOR_ADMIN_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}